import { Document, Page } from "react-pdf";

const SourcePDFView = () => {
  return <></>;
};

export default SourcePDFView;
